import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { useState, type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationTray } from '@/components/NotificationTray';
import { useNotificationContext } from '@/context/notificationContext';

export function NotificationButton() {
  const { t } = useTranslation('entity-portal');
  const { unreadCount } = useNotificationContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t('common.notifications')}>
        <IconButton
          size="small"
          aria-label={t('common.notifications')}
          aria-controls={anchorEl ? 'notification-tray' : undefined}
          aria-haspopup="true"
          aria-expanded={anchorEl ? 'true' : undefined}
          onClick={handleOpen}
        >
          <Badge
            color="error"
            badgeContent={unreadCount}
            invisible={unreadCount === 0}
            max={99}
          >
            <NotificationsNoneIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>

      <NotificationTray
        anchorEl={anchorEl}
        onClose={handleClose}
      />
    </>
  );
}
